// extracted by mini-css-extract-plugin
export default {"analyze__btn":"styles_analyze__btn__wdoL1","analyze__modal":"styles_analyze__modal__RO+oy","analyze__title":"styles_analyze__title__64wE-"};